import PropTypes from 'prop-types';

export const AutoCompleteResultCoordinatesType = PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lon: PropTypes.number.isRequired,
});

export const BasicAutocompleteResultTypeShape = {
    country: PropTypes.string.isRequired,
    // If the city isn't from flixbus network it can have no id and legacyId
    id: PropTypes.string,
    legacyId: PropTypes.number,
    name: PropTypes.string.isRequired,
    timezoneOffset: PropTypes.number,
};

export const AutocompleteResultType = PropTypes.shape({
    ...BasicAutocompleteResultTypeShape,
    // unique hash to be used as reactComponent key
    hash: PropTypes.string.isRequired,
    score: PropTypes.number.isRequired,
    location: AutoCompleteResultCoordinatesType.isRequired,
    district: PropTypes.string,
    isFlixbusCity: PropTypes.bool.isRequired,
    hasTrainStation: PropTypes.bool,
    continent: PropTypes.string.isRequired,
});

export const AutocompleteResultCollectionType = PropTypes.arrayOf(AutocompleteResultType);

// custom validator is needed for deeply validating values of a Map object
export const AutoCompleteResultByContinentType = (props, propName, componentName) => {
    const continents = props[propName];

    if (!continents) {
        return new Error(`Required property ${propName} not supplied.`);
    }

    if (!(continents instanceof Map)) {
        return new Error(`${propName} should be of type Map.`);
    }

    try {
        continents.forEach((results) => {
            PropTypes.checkPropTypes(
                { collection: AutocompleteResultCollectionType },
                { collection: results },
                'collection',
                componentName,
            );
        });
    } catch (err) {
        return err;
    }

    return null;
};
